var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.linked ? 'nuxt-link' : 'span',{tag:"component",staticClass:"product-tag-stamp",attrs:{"to":{name: 'products', query: {'q[tag_ids]': _vm.data.id}}},domProps:{"textContent":_vm._s(_vm.data.name)}})
}
var staticRenderFns = []

export { render, staticRenderFns }